(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  const stages = document.querySelectorAll('[data-collage-stage]');
  if (!stages.length) return;

  stages.forEach((stage) => {
    const items = stage.querySelectorAll('[data-collage-item]');
    if (!items.length) return;

    let rect = stage.getBoundingClientRect();
    let rafId = null;
    let target = { x: 0.5, y: 0.5 };
    let current = { x: 0.5, y: 0.5 };
    let active = false;
    let touching = false;

    const updateRect = () => { rect = stage.getBoundingClientRect(); };
    window.addEventListener('resize', updateRect, { passive: true });
    window.addEventListener('scroll', updateRect, { passive: true });

    const applyOffsets = () => {
      const ox = current.x - 0.5;
      const oy = current.y - 0.5;
      items.forEach((el) => {
        const depth = parseFloat(el.dataset.depth || '20');
        const factor = isTouch ? 0.75 : 1;
        el.style.setProperty('--mx', `${(-ox * depth * factor).toFixed(2)}px`);
        el.style.setProperty('--my', `${(-oy * depth * factor).toFixed(2)}px`);
      });
    };

    const loop = () => {
      current.x += (target.x - current.x) * 0.12;
      current.y += (target.y - current.y) * 0.12;
      applyOffsets();
      const delta = Math.abs(target.x - current.x) + Math.abs(target.y - current.y);
      if (delta > 0.001) rafId = requestAnimationFrame(loop);
      else { active = false; cancelAnimationFrame(rafId); }
    };

    const start = () => { if (!active) { active = true; loop(); } };

    const setPointer = (clientX, clientY) => {
      updateRect();
      const x = (clientX - rect.left) / rect.width;
      const y = (clientY - rect.top) / rect.height;
      target.x = Math.max(0, Math.min(1, x));
      target.y = Math.max(0, Math.min(1, y));
      start();
    };

    // --- Pointer-driven parallax ---
    stage.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') touching = true;
      setPointer(e.clientX, e.clientY);
    }, { passive: true });

    stage.addEventListener('pointermove', (e) => {
      setPointer(e.clientX, e.clientY);
    }, { passive: true });

    const endTouch = (e) => { if (e.pointerType === 'touch') touching = false; };
    stage.addEventListener('pointerup', endTouch, { passive: true });
    stage.addEventListener('pointercancel', endTouch, { passive: true });
    stage.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'mouse') {
        target.x = 0.5; target.y = 0.5; start();
      } else endTouch(e);
    }, { passive: true });

    // --- Device-orientation parallax ---
    let orientationEnabled = false;
    let calibration = null;

    const handleOrientation = (e) => {
      if (touching) return;
      if (e.beta == null || e.gamma == null) return;
      if (!calibration) calibration = { beta: e.beta, gamma: e.gamma };

      const screenAngle =
        (screen.orientation && screen.orientation.angle) || window.orientation || 0;
      let dBeta = e.beta - calibration.beta;
      let dGamma = e.gamma - calibration.gamma;
      let xTilt, yTilt;
      switch (screenAngle) {
        case 90:  xTilt =  dBeta;  yTilt = -dGamma; break;
        case -90:
        case 270: xTilt = -dBeta;  yTilt =  dGamma; break;
        case 180: xTilt = -dGamma; yTilt = -dBeta;  break;
        default:  xTilt =  dGamma; yTilt =  dBeta;  break;
      }

      const maxTilt = 20;
      const normX = Math.max(-1, Math.min(1, xTilt / maxTilt));
      const normY = Math.max(-1, Math.min(1, yTilt / maxTilt));
      target.x = 0.5 + normX * 0.5;
      target.y = 0.5 + normY * 0.5;
      start();
    };

    const attachOrientationListener = () => {
      window.addEventListener('deviceorientation', handleOrientation, { passive: true });
      orientationEnabled = true;
    };

    const hasOrientation = typeof DeviceOrientationEvent !== 'undefined';
    const needsPermission =
      hasOrientation && typeof DeviceOrientationEvent.requestPermission === 'function';

    console.log('[hero-collage] isTouch:', isTouch,
                'hasOrientation:', hasOrientation,
                'needsPermission:', needsPermission);

    if (isTouch) {
      // Always inject the button on touch devices so it's visible regardless of
      // UA quirks. Handles iOS (requests permission), Android (just enables),
      // and unknown touch devices (shows a friendly fallback).
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hero-collage__motion-btn';
      btn.textContent = 'Tap to enable motion';
      btn.setAttribute('aria-label', 'Enable device motion for the collage');
      stage.parentElement.appendChild(btn);
      console.log('[hero-collage] motion button injected');

      btn.addEventListener('click', () => {
        console.log('[hero-collage] motion button tapped');

        if (needsPermission) {
          DeviceOrientationEvent.requestPermission()
            .then((state) => {
              console.log('[hero-collage] permission state:', state);
              if (state === 'granted') {
                attachOrientationListener();
                btn.remove();
              } else {
                btn.textContent = 'Motion denied';
                setTimeout(() => btn.remove(), 3000);
              }
            })
            .catch((err) => {
              btn.textContent = 'Motion error — see console';
              console.warn('[hero-collage] permission error:', err);
            });
        } else if (hasOrientation) {
          attachOrientationListener();
          btn.remove();
        } else {
          btn.textContent = 'No motion sensor on this device';
          setTimeout(() => btn.remove(), 3000);
        }
      });

      window.addEventListener('orientationchange', () => { calibration = null; });
    }

    // --- Tap/hover lift on individual images ---
    items.forEach((item) => {
      item.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') item.classList.add('is-hover');
      });
      item.addEventListener('pointerleave', () => item.classList.remove('is-hover'));
      item.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') item.classList.add('is-hover');
      }, { passive: true });
      const clearTap = () => item.classList.remove('is-hover');
      item.addEventListener('pointerup', clearTap, { passive: true });
      item.addEventListener('pointercancel', clearTap, { passive: true });
    });
  });
})();